import { render } from "./DialogComment.vue?vue&type=template&id=1e8f9d7a"
import script from "./DialogComment.vue?vue&type=script&lang=js"
export * from "./DialogComment.vue?vue&type=script&lang=js"

import "./DialogComment.vue?vue&type=style&index=0&id=1e8f9d7a&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__